import axios from 'axios'

export default class KitsuApi {
  constructor () {
    KitsuApi._apiUrl = 'https://kitsu.io/api/edge'
    KitsuApi._headers = {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json'
    }
    KitsuApi._maxItems = 20
  }

  _addFilterRange (params = {}, name = '', value) {
    let newParams = Object.assign({}, params)

    if (Array.isArray(value) && value.length > 0) {
      let start = value[0] ? value[0] : ''
      let end = value[1] ? value[1] : ''
      newParams[`filter[${name}]`] = `${start}..${end}`
    } else if (!Array.isArray(value) && value) {
      newParams[`filter[${name}]`] = `${value}..${value}`
    }

    return newParams
  }

  get (endPoints = '', params = {}) {
    return axios.get(
      `${KitsuApi._apiUrl}${endPoints}`, { params, headers: KitsuApi._headers }
    ).then((res) => {
      return res.data.data
    }).catch((err) => {
      throw new Error(err.response.data)
    })
  }

  async browse ({
    year = [],
    rating = [],
    sort = '',
    limit = 20,
    offset = 0
  } = {}) {
    let params = {}

    params = this._addFilterRange(params, 'year', year)
    params = this._addFilterRange(params, 'averageRating', rating)

    if (typeof sort === 'string' && sort !== '') {
      params.sort = sort
    }

    if (typeof limit !== 'number') {
      limit = parseInt(limit, 10)
    }
    if (limit > 200) limit = 200
    if (limit < KitsuApi._maxItems) {
      params['page[limit]'] = limit
    } else {
      params['page[limit]'] = KitsuApi._maxItems
    }

    if (typeof offset !== 'number') {
      offset = parseInt(offset, 10)
    }

    const requests = []
    while (limit > 0) {
      limit -= KitsuApi._maxItems
      params['page[offset]'] = offset
      requests.push(this.get('/anime', Object.assign({}, params)))
      offset += KitsuApi._maxItems
    }

    const result = await Promise.all(requests)
    const animes = result.reduce((accumulator, currentValue) => {
      return accumulator.concat(currentValue)
    })

    return Promise.resolve(animes)
  }
}



// WEBPACK FOOTER //
// ./src/services/kitsu-api.js